// document.addEventListener("turbolinks:load", () => {
//   if ($('#mapid').length>0) {
//     var mymap = L.map('mapid').setView([51.505, -0.09], 13);
//
//     L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiMXc0biIsImEiOiJja2JsZTIxNHkwMWJ2MnhtaWM2NjNzMWY5In0.ZNG_8pJaqUl8QRljg5C1hQ', {
//   		maxZoom: 18,
//   		attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
//   			'<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
//   			'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
//   		id: 'mapbox/streets-v11',
//   		tileSize: 512,
//   		zoomOffset: -1
//   	}).addTo(mymap);
//   }
//
// })
document.addEventListener("turbolinks:load", () => {  // iwan
  // window.disposeEventMap = () => {
  //   window.eventMap.remove();
  //   window.eventMap = null;
  // }

  if ($('#map-to-show').length>0) {
    window.eventMap = L.map('map-to-show');
    var lat = $('#map-to-show').data('latitude')
    var lng = $('#map-to-show').data('longitude')

    window.eventMarker = null
    if (lat && lng) {
      eventMap.setView([lat || 45.472584, lng || 9.195423], 6);
      eventMarker = L.marker([lat, lng]).addTo(eventMap)
    } else {
      eventMap.setView([45.472584, 9.195423], 1);
    }

    const eventTileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiMXc0biIsImEiOiJja2hlc3NhaXcwYjN6MnJsdTRpYWcyczN2In0.LlYl7KJBquGkTOihGZAttw', {
      maxZoom: 18,
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      id: 'mapbox/streets-v11',
      tileSize: 512,
      zoomOffset: -1
    });
    eventTileLayer.addTo(eventMap);
  }




  // window.showEventMap = () => {
  if ($('#map-to-edit').length>0) {
    // console.log('---pass---');
    window.eventMap = L.map('map-to-edit');
    var lat = $('#event_latitude').val()
    var lng = $('#event_longitude').val()
    eventMap.setView([lat || 45.472584, lng || 9.195423], 13);
    $('#lat-value').text(lat)
    $('#lon-value').text(lng)

    window.eventMarker = null
    // let eventMarker = null
    if (lat && lng) {
      eventMarker = L.marker([lat, lng]).addTo(eventMap)
    }

    const eventTileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiMXc0biIsImEiOiJja2hlc3NhaXcwYjN6MnJsdTRpYWcyczN2In0.LlYl7KJBquGkTOihGZAttw', {
      maxZoom: 18,
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      id: 'mapbox/streets-v11',
      tileSize: 512,
      zoomOffset: -1
    });
    eventTileLayer.addTo(eventMap);


    function onMapClick(e) {
      console.log(e);
      if (eventMarker!=null) {
        eventMarker.remove();
      }
      var ll = e.latlng;
      eventMarker = L.marker([ll.lat, ll.lng]).addTo(eventMap);

      $('#event_latitude').val(ll.lat)
      $('#event_longitude').val(ll.lng)
      $('#lat-value').text(ll.lat)
      $('#lon-value').text(ll.lng)
    }

    eventMap.on('click', onMapClick);

    // search
    var searchControl = new L.esri.Controls.Geosearch().addTo(eventMap);
    var results = new L.LayerGroup().addTo(eventMap);
    searchControl.on('results', function(data){
      results.clearLayers();
      for (var i = data.results.length - 1; i >= 0; i--) {
        if (eventMarker!=null) {
          eventMarker.remove();
        }
        var ll = data.results[i].latlng;
        eventMarker = L.marker(ll);
        results.addLayer(eventMarker);
        $('#event_latitude').val(ll.lat)
        $('#event_longitude').val(ll.lng)

      }
    });
  }
  // }


  $('#clear-position-btn').on('click', function() {
    if (eventMarker!=null) {
      eventMarker.remove();
      $('#event_latitude').val('')
      $('#event_longitude').val('')
      $('#lon-value').text('')
      $('#lat-value').text('')
    }
  })

})
